import React from "react";

export default function Footer() {
  return (
    <footer className="shc-footer" id="contact">
      <div className="container">
        <div className="row gy-4">
          <div className="col-12 col-md-4">
            <a href="#home" className="shc-logo mb-3 d-inline-flex">
              <span>
                ST<span className="star">☆</span>R HOME CINEMAS
              </span>
              <small>ESTD. 2006</small>
            </a>
            <p className="mt-3">
              Crafting luxury home cinema and private theatre experiences since 2006.
            </p>
            <div className="mt-3">
              <a href="#facebook" className="shc-footer-social" aria-label="Facebook">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="#instagram" className="shc-footer-social" aria-label="Instagram">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="#youtube" className="shc-footer-social" aria-label="YouTube">
                <i className="bi bi-youtube"></i>
              </a>
              <a href="#pinterest" className="shc-footer-social" aria-label="Pinterest">
                <i className="bi bi-pinterest"></i>
              </a>
              <a href="#linkedin" className="shc-footer-social" aria-label="LinkedIn">
                <i className="bi bi-linkedin"></i>
              </a>
            </div>
          </div>

          <div className="col-6 col-md-2">
            <h5>Quick Links</h5>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#projects">Projects</a></li>
              <li><a href="#technology">Technology</a></li>
              <li><a href="#blog">Blog</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="col-6 col-md-3">
            <h5>Our Services</h5>
            <ul>
              <li><a href="#services">Design &amp; Consultation</a></li>
              <li><a href="#services">Acoustic Treatment</a></li>
              <li><a href="#services">Audio Visual Integration</a></li>
              <li><a href="#services">Interiors &amp; Lighting</a></li>
              <li><a href="#services">Seating &amp; Accessories</a></li>
            </ul>
          </div>

          <div className="col-12 col-md-3">
            <h5>Contact Us</h5>
            <ul>
              <li>
                <a href="tel:+911234567890">
                  <i className="bi bi-telephone me-2"></i>+91 12345 67890
                </a>
              </li>
              <li>
                <a href="mailto:info@starhomecinemas.com">
                  <i className="bi bi-envelope me-2"></i>info@starhomecinemas.com
                </a>
              </li>
              <li className="d-flex">
                <i className="bi bi-geo-alt me-2 mt-1"></i>
                <span>No. 123, Cinema Street, Chennai — 600123, India</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="shc-footer-bottom d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
          <span>&copy; {new Date().getFullYear()} Star Home Cinemas. All Rights Reserved.</span>
          <span>
            <a href="#privacy">Privacy Policy</a> &nbsp;|&nbsp; <a href="#terms">Terms &amp; Conditions</a>
          </span>
        </div>
      </div>
    </footer>
  );
}
